import browser from '../../../../assets/whoswatchingme/browser.gif'
import trackingintro from '../../../../assets/whoswatchingme/trackingintro.png'
import contenttypeflower from '../../../../assets/whoswatchingme/contenttypeflower.png'
import contenttypeplot from '../../../../assets/whoswatchingme/contenttypeplot.png'

import set from '../../../../assets/set.gif'

import createbag from '../../../../assets/clothespin/createbag.png'
import shifts from '../../../../assets/clothespin/shifts.png'
import announcements from '../../../../assets/clothespin/announcements.png'
import bulkactions from '../../../../assets/clothespin/bulkactions.png'
import createannouncement1 from '../../../../assets/clothespin/createannouncement1.png'
import createannouncement2 from '../../../../assets/clothespin/createannouncement2.png'

import customerapp from '../../../../assets/clothespin/customerapp.png'

import dahome from '../../../../assets/clothespin/dahome.jpg'
import dalogin from '../../../../assets/clothespin/dalogin.jpg'
import danewshift from '../../../../assets/clothespin/danewshift.jpg'
import dashift from '../../../../assets/clothespin/dashift.jpg'

import customersite from '../../../../assets/clothespin/customersite.png'
import customersite1 from '../../../../assets/clothespin/customersite1.png'
import customersite2 from '../../../../assets/clothespin/customersite2.png'

import queue1 from '../../../../assets/queue/queue1.png'
import queue2 from '../../../../assets/queue/queue2.png'
import queue3 from '../../../../assets/queue/queue3.png'

import website from '../../../../assets/website.png'

const projects = [
  {
    title: `Who's Watching Me?`,
    tools: 'Made with HTML, CSS, JavaScript, and D3',
    description:
      `<span>For my data visualization class, my team and I built this <a href="https://amazing-roentgen-e4089f.netlify.app/">website</a> of visualizations to provide insight into internet tracking.</span>`,
    photos: [
      {
        feature: trackingintro,
        gallery: [trackingintro]
      },
      {
        feature: contenttypeplot,
        gallery: [contenttypeplot]
      },
      {
        feature: contenttypeflower,
        gallery: [contenttypeflower]
      },
      {
        feature: browser,
        gallery: [browser]
      }
    ]
  },
  {
    title: 'SET',
    tools: 'Made with Swift',
    description:
      'I built myself an iOS version of the card game SET so that I could play it during my commute one summer. There is a color toggle to switch between the default color scheme (graphics from Vincent Woo) and color-blind friendly ones (added so I could play with my color-blind friends). The game runs through the standard 81-card deck, but there is also a cumulative score so that I could play several rounds on the train ride. The +3 button serves to add cards if there is no set on the board or give a hint if there is a set on the board that was missed.\n\n(Not conveyed by the gif: happy sound effects for successfully taking a set or recognizing that there were no sets, and a buzzer for trying to add 3 cards when there was still a set on the board.)',
    photos: [
      {
        feature: set,
        gallery: [set]
      }
    ]
  },
  {
    title: 'Clothespin',
    tools: 'Made with React, GraphQL, MongoDB',
    description:
      "I PMed the HSA DEV team that built Clothespin, a suite of two websites and two mobile apps for a student laundry service. We built (starting from the top and moving clockwise): an administrator website (for overseeing the business, coordinating pickups, and managing payment), a customer app and a customer website for customers (to receive announcements, request laundry pickup, and track their laundry's status), and a delivery app (for employees to pick up dirty laundry or drop off clean laundry). (Click the images to see more screenshots of the projects.)",
    photos: [
      {
        feature: createbag,
        gallery: [
          createbag,
          bulkactions,
          shifts,
          announcements,
          createannouncement1,
          createannouncement2
        ]
      },
      {
        feature: customerapp,
        gallery: [customerapp]
      },
      {
        feature: dahome,
        gallery: [dalogin, dahome, danewshift, dashift]
      },
      {
        feature: customersite,
        gallery: [customersite, customersite1, customersite2]
      }
    ]
  },
  {
    title: 'FoodGroups',
    tools: 'Made with Flask and HTML/CSS',
    description:
      'For my CS50 final project, I worked on a web app that suggested restaurants to groups of users with different preferences and dietary restrictions.'
  },
  {
    title: 'Queue',
    tools: 'Made with Swift, Firebase',
    description:
      "For my high school Senior Honors Project, I built a prototype of a to-do list app that predicted each task's priority based on keywords and prioritized tasks based on importance and due date. Users could create an account, log in, make categories, create/edit/delete tasks, and add/edit/delete priority keywords used to predict the importance of tasks. The tasks were displayed in short-term and long-term lists in an order that reflected the importance and imminence of the tasks, and users could check off completed tasks.",
    photos: [
      {
        feature: queue1,
        gallery: [queue1, queue2, queue3]
      }
    ]
  },
  {
    title: 'This Website',
    tools: 'Made with React',
    description:
      'I built this website to share some of the things I love to do :)',
    photos: [
      {
        feature: website,
        gallery: [website]
      }
    ]
  }
]

export default projects



// WEBPACK FOOTER //
// ./src/containers/CS/components/ProjectsCarousel/projects.js